import { http, httpBase } from "./http";

// long-running 작업 (대용량 ZIP 생성, 파일 업로드, S3 전송 등) 용 — 5분.
// 기본 30s 로는 부족한 케이스를 모아 처리. 호출 시 config.timeout 으로 추가 override 가능.
const LONG_RUN_TIMEOUT_MS = 5 * 60 * 1000;

function methods(instance) {
    return {
        get:      (url, params, config)   => instance.get(url, { params, ...config }),
        post:     (url, data, config)     => instance.post(url, data, config),
        put:      (url, data, config)     => instance.put(url, data, config),
        patch:    (url, data, config)     => instance.patch(url, data, config),
        delete:   (url, config)           => instance.delete(url, config),
        upload:   (url, formData, config) => instance.post(url, formData, {
            headers: { "Content-Type": "multipart/form-data" },
            timeout: LONG_RUN_TIMEOUT_MS,
            ...config,
        }),
        download: (url, params, config)   => instance.get(url, {
            params,
            responseType: "blob",
            timeout: LONG_RUN_TIMEOUT_MS,
            ...config,
        }),
    };
}

export const api     = methods(http);
export const apiBase = methods(httpBase);
